import { CustomColumn } from '../../types/customColumn';
import { QzTrayConfiguration } from '../../types/qztray/QzTrayConfigurationTypes';

/**
 * ⚙️ Columnas para la tabla de configuraciones QZ Tray
 *
 * Muestra información de conexión:
 * - Sucursal / Tipo establecimiento
 * - Tenant ID
 * - Host y puerto
 * - Protocolo
 * - SSL habilitado
 * - Timeout
 * - Última conexión
 * - Estado activo
 */
export const qzTrayConfigurationColumns: CustomColumn<QzTrayConfiguration>[] = [
  {
    Header: 'Sucursal',
    accessor: 'branchId',
    customCell: ({ row }) => (
      <div className="text-sm font-medium text-black dark:text-white">
        {row.original.establishmentType || '—'}
      </div>
    ),
  },
  {
    Header: 'Tenant ID',
    accessor: 'tenantId',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm font-medium">
        {row.original.tenantId || '—'}
      </span>
    ),
  },
  {
    Header: 'Host',
    accessor: 'host',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.host}
      </span>
    ),
  },
  {
    Header: 'Puerto',
    accessor: 'port',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.port}
      </span>
    ),
  },
  {
    Header: 'Protocolo',
    accessor: 'protocol',
    customCell: ({ row }) => (
      <span
        className={`inline-flex items-center gap-1 text-sm font-medium ${
          row.original.protocol === 'wss'
            ? 'text-green-600 dark:text-green-400'
            : 'text-blue-600 dark:text-blue-400'
        }`}
      >
        {row.original.protocol.toUpperCase()}
        {row.original.protocol === 'wss' && (
          <span className="ml-1 text-xs">(seguro)</span>
        )}
      </span>
    ),
  },
  {
    Header: 'SSL',
    accessor: 'sslEnabled',
    customCell: ({ row }) => (
      <span
        className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
          row.original.sslEnabled
            ? 'bg-green-500 text-white'
            : 'bg-[#DC3545] text-white'
        }`}
      >
        {row.original.sslEnabled ? 'Habilitado' : 'Desactivado'}
      </span>
    ),
  },
  {
    Header: 'Timeout (ms)',
    accessor: 'timeoutMs',
    customCell: ({ row }) => (
      <span className="text-gray-500 dark:text-gray-400 text-sm">
        {row.original.timeoutMs}
      </span>
    ),
  },
  {
    Header: 'Última Conexión',
    accessor: 'lastSuccessfulConnection',
    customCell: ({ row }) => (
      <span className="text-gray-500 dark:text-gray-400 text-sm">
        {row.original.lastSuccessfulConnection || '—'}
      </span>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'active',
    customCell: ({ row }) => (
      <span
        className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
          row.original.active
            ? 'bg-green-500 text-white'
            : 'bg-[#DC3545] text-white'
        }`}
      >
        {row.original.active ? 'Activo' : 'Inactivo'}
      </span>
    ),
  },
];
